import { render, staticRenderFns } from "./TrainNewborn.vue?vue&type=template&id=24f5b139&scoped=true&"
import script from "./TrainNewborn.vue?vue&type=script&lang=js&"
export * from "./TrainNewborn.vue?vue&type=script&lang=js&"
import style0 from "./TrainNewborn.vue?vue&type=style&index=0&id=24f5b139&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5b139",
  null
  
)

export default component.exports